import {
	GetSpeakers,
	SaveSpeaker,
} from '../../../connection/speakers';
import type { Action, AsyncAction } from '../../../types/actions';
import type { Speaker } from '../../../types/working-model';

export const GET_SPEAKERS = 'GET_SPEAKERS';
export function getSpeakers(
	channel: number,
	token: string,
	options?: { page?: number; search?: string }
): AsyncAction {
	const page = options?.page ?? 1;

	return {
		type: GET_SPEAKERS,
		promise: GetSpeakers(channel, token, { page, search: options?.search })
			.then(({ results, total }) => ({ results, total, page })),
	};
}

export const SAVE_SPEAKER = 'SAVE_SPEAKER';
export function saveSpeaker(speaker: Speaker, token: string): AsyncAction {
	return {
		type: SAVE_SPEAKER,
		promise: SaveSpeaker(token, speaker),
	};
}

export const CREATE_SPEAKER = 'CREATE_SPEAKER';
export function createSpeaker(speaker: Speaker): Action {
	return {
		type: CREATE_SPEAKER,
		payload: speaker,
	};
}

export const UPDATE_SPEAKER = 'UPDATE_SPEAKER';
export function updateSpeaker(speaker: Speaker): Action {
	return {
		type: UPDATE_SPEAKER,
		payload: speaker,
	};
}
